import React, { useState } from "react";
import styled from "styled-components";
import { FaFilePdf, FaFileAlt } from "react-icons/fa";
import DocumentViewModal from "../Elements/DocumentViewModal";

const DocumentPreview = ({ documents, handleDelete, deleting }) => {
  const [previewUrl, setPreviewUrl] = useState(null);

  const getFilePreview = (doc) => {
    const extension = doc.extension.toLowerCase();
    if (["jpg", "jpeg", "png", "gif"].includes(extension)) {
      return <img src={doc.url_path} alt={doc.name} />;
    } else if (extension === "pdf") {
      return <FaFilePdf />;
    } else {
      return <FaFileAlt />;
    }
  };

  return (
    <>
      <DocumentGrid>
        {documents.map((doc) => (
          <DocumentCard key={doc.uuid}>
            <PreviewWrapper onClick={() => setPreviewUrl(doc.url_path)}>
              {getFilePreview(doc)}
            </PreviewWrapper>
            {/* <button onClick={() => handleDelete(doc.uuid)} disabled={deleting} >
              <FaTrash />
            </button> */}
          </DocumentCard>
        ))}
      </DocumentGrid>

      {previewUrl && (
        <DocumentViewModal onClose={() => setPreviewUrl(null)}>
          <iframe src={previewUrl} title="Document Preview" />
        </DocumentViewModal>
      )}
    </>
  );
};

const DocumentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;

  @media (max-width: 960px) {
    grid-template-columns: repeat(2, 1fr); /* 2 items per row */
  }

  @media (max-width: 400px) {
    grid-template-columns: 1fr; /* 1 item per row for very small screens */
  }
`;

const DocumentCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f9f9f9;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  position: relative;

  svg, img {
    width: 50px;
    height: 50px;
  }

  img {
    object-fit: cover;
    border-radius: 5px;
  }

  button {
    background: none;
    border: none;
    color: red;
    cursor: pointer;
    margin-top: 5px;

    &:hover {
      color: darkred;
    }
  }
`;

const PreviewWrapper = styled.div`
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;


export default DocumentPreview;
